import useDashboardScrollRestore from "../../DashboardCourses/hooks/useDashboardScrollRestore";
import {
  clearStudyDashboardScrollState,
  readStudyDashboardScrollState,
} from "../utils/studyDashboardScrollRestore";

/**
 * Restores vertical scroll (and optional quick-action card anchor) when returning to Study Dashboard.
 */
const useStudyDashboardScrollRestore = ({ isReady, restoreTrigger }) =>
  useDashboardScrollRestore({
    isReady,
    restoreTrigger,
    readScrollState: readStudyDashboardScrollState,
    clearScrollState: clearStudyDashboardScrollState,
  });

export default useStudyDashboardScrollRestore;
